import { render } from "./App.vue?vue&type=template&id=696a19dd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=696a19dd&lang=css"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__